import NavFooter from './NavFooter.vue';
import NavHeader from './NavHeader.vue';

import ListPagination from '@/components/ListPagination.vue';
import RegionTree from '@/components/RegionTree.vue';
import FileUpload from "@/components/FileUpload.vue"
import UserList from "@/components/UserList.vue"
import QrCode from "@/components/QrCode.vue"
import UeEditor from "@/components/UeEditor.vue"
import NaviMap from "@/components/NaviMap.vue"
import FileView from "@/components/FileView.vue"

const components = {
    install: function (Vue) {
        Vue.component('NavHeader', NavHeader);
        Vue.component('NavFooter', NavFooter);
        Vue.component('ListPagination', ListPagination);
        Vue.component('RegionTree', RegionTree);
        Vue.component('FileUpload', FileUpload);
        Vue.component('QrCode', QrCode);
        Vue.component('UserList', UserList);
        Vue.component('UeEditor', UeEditor);
        Vue.component('NaviMap', NaviMap);
        Vue.component('FileView', FileView);
    }
}

export default components;


// WEBPACK FOOTER //
// ./src/pages/pc/components/shared/high-components.js